import InputField from "components/fields/InputField";
import Card from "components/card";
import { useState } from "react";
import axiosClient from "axios-client.js";
import Loading from "components/loading/Loading";
import { Link, useNavigate } from "react-router-dom";

let returnTimeout;

export default function ForgotPassword() {
    const [message, setMessage] = useState({});
    const [load, setLoad] = useState(false);
    const [state, setState] = useState({
        email: null,
    });
    const navigate = useNavigate();

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setState((state) => ({ ...state, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoad(true);
        setMessage({});
        axiosClient
            .post("/auth/reset-password", state)
            .then(({ data }) => {
                setLoad(false);
                setMessage({ text: data.message, type: "SUCCESS" });
                returnTimeout = setTimeout(() => {
                    navigate("/auth/sign-in", {
                        replace: true,
                    });
                }, 5000);
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    };
    return (
        <div className="mt-0 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mt-16 lg:mb-10 lg:items-center lg:justify-start">
            {/* Forgot password section */}
            {load ? <Loading /> : null}
            <div className="mx-auto mt-0 w-full max-w-full flex-col items-center lg:mt-[10vh] xl:max-w-[544px]">
                <Card extra="p-6 md:p-[32px]">
                    <Link to="/auth/sign-in">
                        <img
                            src="/img/logo.svg"
                            alt="Proxima"
                            className="mx-auto mb-4 w-64 p-0"
                        />
                    </Link>
                    <hr className="-mx-6 mb-6 border-lightPrimary md:-mx-[40px]" />
                    <h4 className="mb-2.5 text-center text-3xl font-bold text-gray-800 dark:text-white">
                        Password dimenticata?
                    </h4>
                    <p className="mb-6 ml-1 text-center text-[14.5px] text-gray-800">
                        Inserisci la tua e-mail: riceverai un link per
                        reimpostare la password.
                    </p>
                    <form onSubmit={handleSubmit}>
                        {message.hasOwnProperty("text") ? (
                            <div
                                className={
                                    "mb-3 ml-1 text-center text-base " +
                                    (message.type === "SUCCESS"
                                        ? "text-green-500"
                                        : message.type === "ERROR"
                                        ? "text-red-500"
                                        : message.type === "WARNING"
                                        ? "text-amber-500"
                                        : null)
                                }
                            >
                                <p>{message.text}</p>
                            </div>
                        ) : null}
                        {message.type === "SUCCESS" ? (
                            <div className="flex items-center justify-center self-center">
                                <button
                                    type="button"
                                    className="linear mb-2 rounded-[8px] bg-brand-500 py-[2px] px-[4px] text-base font-bold text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                                    onClick={() => {
                                        navigate("/auth/sign-in", {
                                            replace: true,
                                        });
                                        clearTimeout(returnTimeout);
                                    }}
                                >
                                    Torna al login
                                </button>
                            </div>
                        ) : null}
                        {/* Email */}
                        <InputField
                            extra="mb-4"
                            label="Email*"
                            placeholder="info@myproxima.info"
                            name="email"
                            type="email"
                            value={state.email || ""}
                            onChange={handleChange}
                            required={true}
                            state={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("email")
                                        ? "error"
                                        : null
                                    : null
                            }
                            error={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty("email")
                                        ? message.errors.email
                                        : null
                                    : null
                            }
                        />

                        <div className="flex flex-col gap-3">
                            <button
                                type="submit"
                                className="linear mt-2 w-full rounded-[8px] bg-brand-500 py-[12px] text-base font-bold uppercase text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                            >
                                Invia link reset
                            </button>

                            <Link to="/auth/sign-in">
                                <button className="linear bg-transparent w-full rounded-[8px] border border-brand-500 px-[34px] py-[12px] text-base font-bold uppercase text-brand-500 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 active:text-white dark:bg-brand-400 dark:text-brand-500 dark:hover:bg-brand-300 dark:hover:text-white dark:active:bg-brand-200 dark:active:text-white">
                                    Indietro
                                </button>
                            </Link>
                        </div>
                    </form>
                </Card>
            </div>
        </div>
    );
}
